import { ArrowRight, Shield, Database, Key } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function HeroSection({ onOpenForm }) {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1771098302209-a1f7d252085c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0ZXh0aWxlJTIwZmFjdG9yeSUyMGRhcmslMjBjaW5lbWF0aWMlMjBsaWdodGluZ3xlbnwwfHx8fDE3NzIzNDQwMzF8MA&ixlib=rb-4.1.0&q=85')`,
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Grid Pattern */}
      <div className="absolute inset-0 grid-bg opacity-10" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-12 pt-24 pb-16">
        <div className="text-center max-w-4xl mx-auto">
          {/* Logo */}
          <h1 className="font-heading text-6xl md:text-8xl font-bold tracking-tight mb-6" data-testid="hero-title">
            <span className="text-[#F59E0B]">Kp</span>
            <span className="text-[#E5E7EB]">Action</span>
          </h1>

          {/* Tagline */}
          <p className="font-heading text-2xl md:text-4xl font-medium text-[#E5E7EB] mb-4 tracking-tight">
            Crescimento exige mais do que esforço.
          </p>
          <p className="font-heading text-2xl md:text-4xl font-medium text-[#F59E0B] mb-8 tracking-tight">
            Exige leitura estrutural.
          </p>

          {/* Description */}
          <p className="text-sm md:text-lg text-[#9CA3AF] max-w-2xl mx-auto mb-10 leading-relaxed px-6 md:px-0">
            Empresas sólidas não dependem apenas de experiência. Elas enxergam antes.
            <br /><br />
            <span className="text-[#E5E7EB]">
              KpAction é um software que analisa a estrutura da sua operação como um sistema dinâmico, revelando diariamente seu estado e gerando insights que permitem antecipar quando ela deixará de sustentar sua capacidade de entrega ou suas metas de crescimento.
            </span>
          </p>

          {/* Impact Statement */}
          <div className="w-12 h-px bg-[#2A2F38] mx-auto mb-8" />
          <p className="text-sm md:text-base text-[#F59E0B] max-w-xl mx-auto mb-10 leading-relaxed px-6 md:px-0 font-medium">
            Antecipe quando a dinâmica da sua operação começará a comprometer prazos, metas ou capacidade de entrega.
          </p>

          {/* CTA */}
          <Button
            onClick={onOpenForm}
            className="bg-[#F59E0B] text-black font-bold uppercase tracking-wide hover:bg-[#D97706] transition-all rounded-sm px-10 py-6 text-base shadow-glow hover:shadow-glow-strong mb-10"
            data-testid="hero-cta-button"
          >
            Testar gratuitamente por 30 dias
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>

          {/* Features */}
          <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-3 md:gap-6 text-xs md:text-sm text-[#9CA3AF] px-6 md:px-0">
            <div className="flex items-center gap-1.5 md:gap-2">
              <Database className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#F59E0B] flex-shrink-0" />
              <span>Executável offline</span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2">
              <Key className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#F59E0B] flex-shrink-0" />
              <span>Licença anual</span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2">
              <Shield className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#F59E0B] flex-shrink-0" />
              <span>Ativação por chave</span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2">
              <Database className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#F59E0B] flex-shrink-0" />
              <span>Controle total dos seus dados</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-[#2A2F38] flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-[#F59E0B] rounded-full" />
        </div>
      </div>
    </section>
  );
}
